module.exports = __webpack_public_path__ + "static/media/apartment11.872f7ed1.png";